import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "searchContainer" }
const _hoisted_2 = { class: "search" }
const _hoisted_3 = { class: "searchInputOutline" }
const _hoisted_4 = ["oninput"]
const _hoisted_5 = {
  key: 1,
  class: "filtersPanel"
}
const _hoisted_6 = {
  key: 0,
  class: "artistLikeThisName"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_keyboard_events = _resolveComponent("keyboard-events")!
  const _component_loading_icon = _resolveComponent("loading-icon")!
  const _component_search_icon = _resolveComponent("search-icon")!
  const _component_chevron_up = _resolveComponent("chevron-up")!
  const _component_chevron_down = _resolveComponent("chevron-down")!
  const _component_plus_icon = _resolveComponent("plus-icon")!
  const _component_metrics_selector = _resolveComponent("metrics-selector")!
  const _component_value_slider = _resolveComponent("value-slider")!
  const _component_flag_label = _resolveComponent("flag-label")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          class: "search",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.text) = $event)),
          oninput: _ctx.getAndDisplaySuggestedFilters,
          placeholder: "type an artist or a metric...",
          onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.activateSuggestedMetricsPanel && _ctx.activateSuggestedMetricsPanel(...args)))
        }, null, 40, _hoisted_4), [
          [_vModelText, _ctx.text]
        ])
      ]),
      _createVNode(_component_keyboard_events, { onKeyupEnter: _ctx.searchOnEnter }, null, 8, ["onKeyupEnter"]),
      _createElementVNode("button", {
        class: "searchBar",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args))),
        onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["enter"])),
        title: "Search"
      }, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_loading_icon, {
              key: 0,
              height: "32",
              width: "32",
              iconColor: "inherit"
            }))
          : (_openBlock(), _createBlock(_component_search_icon, {
              key: 1,
              height: "30",
              width: "30",
              iconColor: "inherit"
            }))
      ], 32),
      _createElementVNode("button", {
        class: "searchBar chevron",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleFiltersPanel())),
        title: "Show Score Filters"
      }, [
        (_ctx.showFiltersPanel)
          ? (_openBlock(), _createBlock(_component_chevron_up, {
              key: 0,
              height: "32",
              iconColor: "inherit"
            }))
          : (_openBlock(), _createBlock(_component_chevron_down, {
              key: 1,
              height: "32",
              iconColor: "inherit"
            }))
      ]),
      _createElementVNode("button", {
        class: "searchBar plusButton",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showNewArtist())),
        title: "Add New Artist"
      }, [
        _createVNode(_component_plus_icon, {
          height: "32",
          width: "28",
          iconColor: "inherit"
        })
      ])
    ]),
    (_ctx.showSuggestedMetricsPanel)
      ? (_openBlock(), _createBlock(_component_metrics_selector, {
          key: 0,
          width: "calc(var(--searchBarWidth) + 92px)",
          color: "yellow",
          style: {"left":"-6px"},
          metrics: _ctx.selectionMetrics,
          onMetricSelected: _ctx.addFilter,
          onMetricUnselected: _ctx.removeFilter,
          onClickOutside: _ctx.deactivateSuggestedMetricsPanel
        }, null, 8, ["metrics", "onMetricSelected", "onMetricUnselected", "onClickOutside"]))
      : _createCommentVNode("", true),
    (_ctx.showFiltersPanel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.artistsLikeThisName)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Showing artists like: " + _toDisplayString(_ctx.artistsLikeThisName), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedFilters, (filter) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "selectedFilter",
              key: filter.filter.metric.id
            }, [
              (filter.filter.metric.type === 'value')
                ? (_openBlock(), _createBlock(_component_value_slider, {
                    key: 0,
                    modelValue: filter.filter.filterValues,
                    "onUpdate:modelValue": ($event: any) => ((filter.filter.filterValues) = $event),
                    label: filter.filter.metric.name,
                    color: filter.filter.metric.color,
                    active: true,
                    range: true,
                    onDiscardMetric: ($event: any) => (_ctx.removeFilter(filter))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "color", "onDiscardMetric"]))
                : (_openBlock(), _createBlock(_component_flag_label, {
                    key: 1,
                    label: filter.filter.metric.name,
                    color: filter.filter.metric.color,
                    active: true,
                    onDiscardMetric: ($event: any) => (_ctx.removeFilter(filter))
                  }, null, 8, ["label", "color", "onDiscardMetric"]))
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}